export default __webpack_public_path__ + "fonts/CiscoSansBold-webfont.eot";